export const CHAT_ATTACHMENT_ACCEPT = "image/*,application/pdf,.pdf,.csv,.txt,.json,.md,.xml,.yaml,.yml,.html,.css,.js,.ts,.py,.sh,.log,.doc,.docx,.xls,.xlsx,.pptx,.zip,.tar,.gz";

export function isSupportedChatAttachmentMimeType(mimeType: string | null | undefined): boolean {
  if (typeof mimeType !== "string") {
    return false;
  }
  return true;
}

export function isImageMimeType(mimeType: string): boolean {
  return mimeType.startsWith("image/");
}

export function attachmentDisplayName(att: { fileName?: string; mimeType: string }): string {
  if (att.fileName) {
    return att.fileName;
  }
  const ext = mimeTypeToExtension(att.mimeType);
  return ext ? `file.${ext}` : "file";
}

function mimeTypeToExtension(mimeType: string): string | null {
  const map: Record<string, string> = {
    "application/pdf": "pdf",
    "text/csv": "csv",
    "text/plain": "txt",
    "application/json": "json",
    "text/markdown": "md",
    "text/html": "html",
    "text/css": "css",
    "text/xml": "xml",
    "application/xml": "xml",
    "application/zip": "zip",
    "application/gzip": "gz",
  };
  return map[mimeType] ?? null;
}
